export const COMMISSION_PERCENT = 9.5;
const COMMISSION_BASIS_POINTS = 950;

export function parsePriceCents(
  value: string,
  allowZero = false,
): number | null {
  const text = value.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;

  const [dollars, fraction = ""] = text.split(".");
  const cents = Number(dollars) * 100 + Number(fraction.padEnd(2, "0"));
  if (
    cents < 0 ||
    (!allowZero && cents === 0) ||
    !Number.isSafeInteger(cents) ||
    !Number.isSafeInteger(cents * COMMISSION_BASIS_POINTS)
  )
    return null;

  return cents;
}

export function estimateProceeds(priceCents: number) {
  const commissionCents = Math.round(
    (priceCents * COMMISSION_BASIS_POINTS) / 10000,
  );
  return { commissionCents, proceedsCents: priceCents - commissionCents };
}

export function formatUsd(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}
